module.exports = __webpack_public_path__ + "img/banner_itemone_bigimg.ed467acd.png";